"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var status_1 = require("@caddigital/sok-reducers/lib/status");
var linkedFolders = require("./components/VektorioProjects/components/LinkedProject/components/LinkedFolders/utils/dispatchers");
var ConnectModal_1 = require("./components/ConnectModal");
var dispatchers_1 = require("./utils/dispatchers");
var VektorioProjects_1 = require("./components/VektorioProjects");
require("./index.scss");
exports.default = (function (props) {
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var linkedFoldersDispatchers = linkedFolders.mapDispatchers((0, react_redux_1.useDispatch)());
    var status = (0, react_redux_1.useSelector)(function (state) { return ({
        status: state.vektorio.detachFolders.status
    }); }).status;
    React.useEffect(function () {
        if (status.isComplete) {
            var timeoutId_1 = setTimeout(function () {
                linkedFoldersDispatchers.clearUnlinkState();
            }, 3000);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [status.value]);
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement(sok_ui_1.RequestStatusBox, { status: status.value, statusList: Object.values(status_1.RequestStatusValue) },
            React.createElement("span", null, (0, translation_1.getLocalization)('vektorio/notification/modal/detaching')),
            React.createElement("span", null, (0, translation_1.getLocalization)('vektorio/notification/modal/detached')),
            React.createElement("span", null, (0, translation_1.getLocalization)('vektorio/notification/modal/detach_failed'))),
        React.createElement("div", { className: 'vektorio-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/vektorio'))),
                React.createElement("div", { className: 'tools' },
                    React.createElement(sok_ui_1.Button, { size: 'medium', color: 'green', iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), onClick: dispatchers.toggleConnectProjects }, (0, translation_1.getLocalization)('vektorio/connectProjects'))),
                React.createElement(VektorioProjects_1.VektorioProjects, { currentProject: props.currentProject }),
                React.createElement(ConnectModal_1.ConnectVektorioProject, { currentProject: props.currentProject, closeModal: dispatchers.toggleConnectProjects })))));
});
